
import { createElement } from "react";

export const eager = true;
export const sync = true;

export interface Props {
  /** @description These tags will be inserted into <head> on the page */
  tags: Tag[];
}

/**
 * @titleBy element
 */
interface Tag {
  /** @description HTML element (e.g. meta) */
  element: string;
  /** @description Element attributes (e.g. name)  */
  attributes?: Attribute[];
}

/**
 * @titleBy name
 */
interface Attribute {
  name: string;
  value?: string;
}

function MetaTags({ tags }: Props) {
  const renderedTags = tags.map((tag) => {
    const attributesObject = tag.attributes
      ? tag.attributes.reduce((acc: Record<string, string>, curr) => {
        acc[curr.name] = curr.value || "";
        return acc;
      }, {})
      : {};

    return createElement(tag.element, attributesObject, null);
  });

  return <>{renderedTags}</>;
}

export default MetaTags;
